<template>
    <div class="fixed bottom-0 z-40 w-full text-center mb-4 px-4" style="max-width: 600px;">
        <div class="flex justify-center bg-azuloscuro w-full rounded-full">
            <div class="w-1/4 cursor-pointer text-gray-500 hover:text-white cursor-pointer pt-3 pb-2">
                <router-link
                    to="/">
                    <img class="fill-current inline-block h-5 line mb-1" src="@/assets/images/menu/home active.svg" v-if="current == 'home'"/>
                    <img class="fill-current inline-block h-5 line mb-1" src="@/assets/images/menu/home inactive.svg" v-else/>
                    <div :class="current == 'home' ? 'text-white' : 'text-disabledmenuitem'" class="text-xs font-semibold" style="">Home</div>
                </router-link>
            </div>
            <div class="w-1/4 cursor-pointer text-disabledmenuitem hover:text-white cursor-pointer pt-3 pb-2">
                <router-link
                    to="/search">
                    <img class="fill-current inline-block h-5 line mb-1" src="@/assets/images/menu/search active.svg" v-if="current == 'search'"/>
                    <img class="fill-current inline-block h-5 line mb-1" src="@/assets/images/menu/search inactive.svg" v-else/>
                    <div :class="current == 'search' ? 'text-white' : 'text-disabledmenuitem'" class="text-xs font-semibold" style="">Buscar Pills</div>
                </router-link>
            </div>
            <div class="w-1/4 cursor-pointer text-disabledmenuitem hover:text-white cursor-pointer pt-3 pb-2">
                <router-link
                    to="/support">
                    <img class="fill-current inline-block h-5 line mb-1" src="@/assets/images/menu/suport active.svg" v-if="current == 'suport'"/>
                    <img class="fill-current inline-block h-5 line mb-1" src="@/assets/images/menu/suport inactive.svg" v-else/>
                    <div :class="current == 'suport' ? 'text-white' : 'text-disabledmenuitem'" class="text-xs font-semibold" style="">Soporte</div>
                </router-link>
            </div>
            <div class="w-1/4 cursor-pointer text-disabledmenuitem hover:text-white cursor-pointer pt-3 pb-2">
                <router-link
                    to="/profile">
                    <img class="fill-current inline-block h-5 line mb-1" src="@/assets/images/menu/user active.svg" v-if="current == 'user'"/>
                    <img class="fill-current inline-block h-5 line mb-1" src="@/assets/images/menu/user inactive.svg" v-else/>
                    <div :class="current == 'user' ? 'text-white' : 'text-disabledmenuitem'" class="text-xs font-semibold" style="">Perfil</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Zondicon from 'vue-zondicons'

    const Menu = {
        name: 'Home',
        layout: 'layout',
        components: {
            Zondicon,
        },
        props: ['current'],
        methods: {
            image(section) {
                return `${section} ${this.current === section ? 'active' : 'inactive'}`
            }
        }
    }

    export default Menu;
</script>
